import { render, staticRenderFns } from "./WDateTime.vue?vue&type=template&id=3b896ec2&"
import script from "./WDateTime.vue?vue&type=script&lang=js&"
export * from "./WDateTime.vue?vue&type=script&lang=js&"
import style0 from "./WDateTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports